<template>
    <div class="pd-12 top-border-bottom">
        <a class="exch-breadcrumb-heading-sec" @click="router.go(-1)">
            <img  src="@/assets/images/back.webp" alt="back" >
            <h5 class="text-capitalize">Deposit</h5>
        </a>
    </div>
    <div class="exch-deposit-wrapper">
        <div class="mr-row-sec">
            <div class="multiSteps-container">
                <div class="multiSteps-points">
                    <div class="points-circle">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="14" viewBox="0 0 11 10" fill="none" class="w-3 h-3"><path d="M4.31258 7.43734L1.97925 5.104L2.42716 4.65609L4.31258 6.5415L8.31258 2.5415L8.7605 2.98942L4.31258 7.43734Z" fill="#E7EAEF" stroke="#E7EAEF" stroke-width="0.8"></path></svg>
                    </div>
                    <div class="points-border"></div>
                    <div class="points-circle">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="14" viewBox="0 0 11 10" fill="none" class="w-3 h-3"><path d="M4.31258 7.43734L1.97925 5.104L2.42716 4.65609L4.31258 6.5415L8.31258 2.5415L8.7605 2.98942L4.31258 7.43734Z" fill="#E7EAEF" stroke="#E7EAEF" stroke-width="0.8"></path></svg>
                    </div>
                    <div class="points-border"></div>
                    <div class="points-circle">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="14" viewBox="0 0 11 10" fill="none" class="w-3 h-3"><path d="M4.31258 7.43734L1.97925 5.104L2.42716 4.65609L4.31258 6.5415L8.31258 2.5415L8.7605 2.98942L4.31258 7.43734Z" fill="#E7EAEF" stroke="#E7EAEF" stroke-width="0.8"></path></svg>
                    </div>
                    <div class="points-border"></div>
                    <div class="points-circle active">4</div>
                </div>
                <div class="multiSteps-name">
                    <div class="title-wrap">{{ $t('enter-amt', 'Enter amount') }}</div>
                    <div class="title-wrap">{{ $t('payment-method', 'Payment Method') }}</div>
                    <div class="title-wrap">{{ $t('make-deposit', 'Make Deposit') }}</div>
                    <div class="title-wrap active">{{ $t('proof', 'Proof') }}</div>
                </div>
            </div>
        </div>
    </div>

    <div class="pd-12">
        <a class="exch-breadcrumb-heading-sec" @click="router.go(-1)">
            <img  src="@/assets/images/back.webp" alt="back" >
            <h5 class="back-btn-bg">{{ $t('back-to-make-deposit', 'Back To Make Deposit') }}</h5>
        </a>
    </div>

    <div class="exch-deposit-wrapper">
        <div class="mr-row-sec mt-0">
            <div class="exch-payment-step-content-wrapper">
                <div class="wallet-list-wrapper">
                    <div class="exch-deposit-amount-sec-step-3">
                        <div class="w-full new-exch-upload-wrapper">
                            <h4>Upload your payment slip below<span class="text-text_error">*</span></h4>
                            <div class="exch-upload-transaction-img-section gap_1" v-if="!previewImageUtr">
                                <div class="upload-img">
                                    <!-- <svg xmlns="http://www.w3.org/2000/svg" width="33" height="32" viewBox="0 0 33 32" fill="none">
                                        <path d="M29.5 14.6667V22.6667C29.5783 23.3422 29.5028 24.0268 29.2792 24.669C29.0556 25.3113 28.6897 25.8947 28.2088 26.3756C27.7279 26.8564 27.1445 27.2224 26.5023 27.4459C25.86 27.6695 25.1755 27.745 24.5 27.6667H8.49997C7.82442 27.745 7.13991 27.6695 6.49765 27.4459C5.85539 27.2224 5.272 26.8564 4.79111 26.3756C4.31023 25.8947 3.94431 25.3113 3.72072 24.669C3.49714 24.0268 3.42167 23.3422 3.49997 22.6667V9.33337C3.42167 8.65782 3.49714 7.97332 3.72072 7.33105C3.94431 6.68879 4.31023 6.1054 4.79111 5.62452C5.272 5.14364 5.85539 4.77771 6.49765 4.55413C7.13991 4.33054 7.82442 4.25507 8.49997 4.33337H19.1666C19.4318 4.33337 19.6862 4.43873 19.8737 4.62626C20.0613 4.8138 20.1666 5.06815 20.1666 5.33337C20.1666 5.59858 20.0613 5.85294 19.8737 6.04048C19.6862 6.22801 19.4318 6.33337 19.1666 6.33337H8.49997C6.3973 6.33337 5.49997 7.2307 5.49997 9.33337V21.6667L8.88663 18.28C9.13838 18.0302 9.47865 17.8901 9.8333 17.8901C10.1879 17.8901 10.5282 18.0302 10.78 18.28L12.0333 19.5334C12.1579 19.6555 12.3255 19.7239 12.5 19.7239C12.6745 19.7239 12.842 19.6555 12.9666 19.5334L19.5533 12.9467C19.805 12.6969 20.1453 12.5567 20.5 12.5567C20.8546 12.5567 21.1949 12.6969 21.4466 12.9467L27.5 19V14.6667C27.5 14.4015 27.6053 14.1471 27.7929 13.9596C27.9804 13.7721 28.2347 13.6667 28.5 13.6667C28.7652 13.6667 29.0195 13.7721 29.2071 13.9596C29.3946 14.1471 29.5 14.4015 29.5 14.6667ZM11.1573 10.3334C10.7146 10.3346 10.2905 10.5115 9.97815 10.8252C9.66579 11.1388 9.49068 11.5637 9.4913 12.0064C9.49192 12.449 9.66821 12.8734 9.98145 13.1862C10.2947 13.499 10.7193 13.6747 11.162 13.6747C11.6047 13.6747 12.0292 13.499 12.3425 13.1862C12.6557 12.8734 12.832 12.449 12.8326 12.0064C12.8332 11.5637 12.6581 11.1388 12.3458 10.8252C12.0334 10.5115 11.6093 10.3346 11.1666 10.3334H11.1573ZM25.2066 6.7067L25.5 6.4147V9.33337C25.5 9.59858 25.6053 9.85294 25.7929 10.0405C25.9804 10.228 26.2347 10.3334 26.5 10.3334C26.7652 10.3334 27.0195 10.228 27.2071 10.0405C27.3946 9.85294 27.5 9.59858 27.5 9.33337V6.4147L27.7933 6.7067C27.9829 6.88334 28.2336 6.97951 28.4927 6.97494C28.7517 6.97036 28.9989 6.86541 29.1821 6.6822C29.3653 6.49898 29.4703 6.2518 29.4749 5.99273C29.4794 5.73366 29.3833 5.48293 29.2066 5.29337L27.2066 3.29337C27.019 3.10643 26.7649 3.00146 26.5 3.00146C26.2351 3.00146 25.981 3.10643 25.7933 3.29337L23.7933 5.29337C23.6167 5.48293 23.5205 5.73366 23.5251 5.99273C23.5296 6.2518 23.6346 6.49898 23.8178 6.6822C24.001 6.86541 24.2482 6.97036 24.5073 6.97494C24.7663 6.97951 25.0171 6.88334 25.2066 6.7067Z" fill="url(#paint0_linear_517_8279)"></path>
                                        <linearGradient id="paint0_linear_517_8279" x1="3.46997" y1="5.02199" x2="32.1899" y2="9.13848" gradientUnits="userSpaceOnUse">
                                            <stop stop-color="#36E2FA"></stop>
                                            <stop offset="1" stop-color="#EBFFBF"></stop>
                                        </linearGradient>
                                    </svg> -->
                                    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24" fill="none"><path d="M21.7491 10.9999V16.9999C21.8078 17.5066 21.7512 18.0199 21.5835 18.5016C21.4158 18.9833 21.1414 19.4209 20.7807 19.7815C20.42 20.1422 19.9825 20.4166 19.5008 20.5843C19.0191 20.752 18.5057 20.8086 17.9991 20.7499H5.99906C5.4924 20.8086 4.97902 20.752 4.49732 20.5843C4.01563 20.4166 3.57808 20.1422 3.21742 19.7815C2.85676 19.4209 2.58232 18.9833 2.41463 18.5016C2.24694 18.0199 2.19034 17.5066 2.24906 16.9999V6.9999C2.19034 6.49324 2.24694 5.97986 2.41463 5.49817C2.58232 5.01647 2.85676 4.57893 3.21742 4.21827C3.57808 3.8576 4.01563 3.58316 4.49732 3.41547C4.97902 3.24778 5.4924 3.19118 5.99906 3.2499H13.9991C14.198 3.2499 14.3887 3.32892 14.5294 3.46957C14.67 3.61023 14.7491 3.80099 14.7491 3.9999C14.7491 4.19882 14.67 4.38958 14.5294 4.53023C14.3887 4.67089 14.198 4.7499 13.9991 4.7499H5.99906C4.42206 4.7499 3.74906 5.4229 3.74906 6.9999V16.2499L6.28906 13.7099C6.47787 13.5226 6.73307 13.4174 6.99906 13.4174C7.26505 13.4174 7.52025 13.5226 7.70906 13.7099L8.64906 14.6499C8.74252 14.7415 8.86818 14.7928 8.99906 14.7928C9.12994 14.7928 9.2556 14.7415 9.34906 14.6499L14.2891 9.7099C14.4779 9.52255 14.7331 9.41742 14.9991 9.41742C15.265 9.41742 15.5203 9.52255 15.7091 9.7099L20.2491 14.2499V10.9999C20.2491 10.801 20.3281 10.6102 20.4687 10.4696C20.6094 10.3289 20.8001 10.2499 20.9991 10.2499C21.198 10.2499 21.3887 10.3289 21.5294 10.4696C21.67 10.6102 21.7491 10.801 21.7491 10.9999ZM7.99206 7.7499C7.66005 7.75083 7.34198 7.88349 7.1077 8.11875C6.87342 8.35401 6.7421 8.67264 6.74256 9.00465C6.74302 9.33666 6.87524 9.65492 7.11017 9.88952C7.34511 10.1241 7.66355 10.2559 7.99556 10.2559C8.32757 10.2559 8.64601 10.1241 8.88095 9.88952C9.11588 9.65492 9.24809 9.33666 9.24856 9.00465C9.24902 8.67264 9.1177 8.35401 8.88342 8.11875C8.64914 7.88349 8.33107 7.75083 7.99906 7.7499H7.99206ZM18.5291 5.0299L18.7491 4.8109V6.9999C18.7491 7.19882 18.8281 7.38958 18.9687 7.53023C19.1094 7.67089 19.3001 7.7499 19.4991 7.7499C19.698 7.7499 19.8887 7.67089 20.0294 7.53023C20.17 7.38958 20.2491 7.19882 20.2491 6.9999V4.8109L20.4691 5.0299C20.6112 5.16238 20.7993 5.23451 20.9936 5.23108C21.1879 5.22765 21.3733 5.14894 21.5107 5.01153C21.6481 4.87411 21.7268 4.68873 21.7302 4.49443C21.7337 4.30013 21.6615 4.11208 21.5291 3.9699L20.0291 2.4699C19.8883 2.3297 19.6977 2.25098 19.4991 2.25098C19.3004 2.25098 19.1098 2.3297 18.9691 2.4699L17.4691 3.9699C17.3366 4.11208 17.2645 4.30013 17.2679 4.49443C17.2713 4.68873 17.35 4.87411 17.4874 5.01153C17.6249 5.14894 17.8102 5.22765 18.0045 5.23108C18.1988 5.23451 18.3869 5.16238 18.5291 5.0299Z" fill="#f75555"></path></svg>
                                </div>
                                <!-- <p>{{ $t('upload-transaction-image', 'Upload Transaction Image') }}</p> -->
                                <div>
                                    <div class="file-upload-sec show">
                                        <label for="file" class="file-upload show">{{ $t('upload', 'Upload') }}</label>
                                        <input class="form-control profit-input opacity-0 drag-drop" @change="onUploadImageHandler($event)" accept=".jpg,.jpeg,.png,.webp" type="file" name="file" multiple="" id="file">
                                    </div>
                                    <span class="mt-1 text-center" style="color: #757575; font-size: 1rem; display: block;">or drop a file right here</span>
                                </div>
                                <div class="exch-upload-image-preview-section">
                                    <img id="ImgPreview" src="" class="upload-image-preview1" />
                                    <input type="button" id="removeImage1" value="x" class="upload-image-preview-close-btn1" /> 
                                </div>
                                <!-- <label class="error_cl" v-if="init.transaction_image_url && !uploadedImage">
                                    {{ $t('please-upload-payment-proof', 'Please Upload Payment Proof*') }}.
                                </label> -->
                            </div>
                            
                        </div>
                        <label class="error_cl" v-if="init.transaction_image_url && !uploadedImage && !previewImageUtr">
                            {{ $t('qr-code-image-is-required', 'QR Code image is required') }}.
                        </label>
                        <div class="exch-upload-transaction-img-section" v-if="previewImageUtr">
                            <div class="fileList">
                                <img class="fileList-img" :src="previewImageUtr" alt="file-list"/>
                                <button class="add-utr-again" @click="clearPaymentSlip()" :disabled="utrLoader">
                                    <i class="fa fa-close"></i>
                                </button>
                                <div class="fileList-loader" v-if="utrLoader">
                                    <div class="loader">
                                        <div class="sk-fading-circle">
                                            <div class="sk-circle1 sk-circle"></div>
                                            <div class="sk-circle2 sk-circle"></div>
                                            <div class="sk-circle3 sk-circle"></div>
                                            <div class="sk-circle4 sk-circle"></div>
                                            <div class="sk-circle5 sk-circle"></div>
                                            <div class="sk-circle6 sk-circle"></div>
                                            <div class="sk-circle7 sk-circle"></div>
                                            <div class="sk-circle8 sk-circle"></div>
                                            <div class="sk-circle9 sk-circle"></div>
                                            <div class="sk-circle10 sk-circle"></div>
                                            <div class="sk-circle11 sk-circle"></div>
                                            <div class="sk-circle12 sk-circle"></div>
                                        </div>
                                    </div>
                                    <span class="count_down_timer">{{ timerValue <= 0 ? '' : timerValue }}</span>
                                </div>
                            </div>
                            <div class="paymentProofFileUploadStatus"v-if="paymentProofFileUploadStatus">{{ paymentProofFileUploadStatus }}</div>
                        </div>
                        
                        <div class="deposit-amount-sec">
                            <div class="basic-amount-feild">
                                <label>{{ $t('unique-transaction-reference', 'Unique Transaction Reference') }}</label>
                                <input type="tel" :maxlength="selectPaymentAccount?.method != 'wallet' ? 15 : 128" class="form-control" v-model="utrNumber" @input="validateUTR(), changeHasEditUtrStatus()" :placeholder="$t('enter-utr-number', 'Enter UTR number ') + ((selectPaymentAccount?.method != 'wallet') ? '*' : '')" :disabled="utrLoader">
                            </div>
                        </div>
                        <label class="error_cl" v-if="init.utr && !utrNumber?.length && selectPaymentAccount?.method != 'wallet'">
                            {{ $t('utr-is-required', 'UTR is required') }}
                        </label>
                        <label class="error_cl" v-else-if="init.utr && utrNumber?.length < 10 && selectPaymentAccount?.method != 'wallet'">
                            {{ $t('utr-limit-msg', 'UTR Number Must be 10 to 15 Digits') }}
                        </label>
                        <a @click="walletDepositSubmitBtn()" class="green-theme-btn mt-1 w-100">
                            {{ $t('i-have-made-the-payment', 'I Have Made The Payment') }}
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- modal popup -->
    <div class="modal fade exch-success-msg-modal" id="exch-success-msg-modalToggle" aria-hidden="true" aria-labelledby="exch-success-msg-modalToggleLabel" tabindex="-1">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content transparent-modal-content">
                <div class="e-p-content-bc1">
                    <div class="e-p-body-bc" style="overflow-y: auto;">
                        <div class="login-page-abc">
                            <div class="login-page">
                                <div class="login-box">
                                    <div class="login-card">
                                        <div class="login-card-header exch-modal-popup-header-section">
                                            <div class="login-text">
                                                <p>{{ $t('deposit', 'Deposit') }}</p>
                                            </div>
                                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"> <i class="fa fa-close"></i> </button>
                                        </div>
                                        <div class="exch-cashout-body-center exch-success-msg-div">
                                            <div class="exch-success-check-div"> <span class="fa fa-check"></span> </div>
                                            <h3>{{ $t('success', 'Success') }}</h3>
                                            <p>{{ $t('acc-add-success', 'Account added successfully') }}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, computed, inject, onMounted } from 'vue';
import { useStore } from 'vuex';
import { getParentPaymentsMethods, ocrCheck, onUploadImage, submitDepositAmount } from '../services/depositPayment';
import { useRouter } from 'vue-router';
import { apiCall as $apiCall } from '@/shared/services/apiCall';
import { translatedData as $t } from '@/shared/services/languageService';
import { errorToast as $errorToast } from '@/shared/services/helper';

const router = useRouter();


// ========== STORE ==========
const store = useStore();

// ========== INJECT ==========
const walletConfig = inject('walletConfig');
const prepareIconUpload = inject('prepareIconUpload');

const loading = ref(false);
const utrLoader = ref(false);
const file = ref(undefined);
const utrNumber = ref(null);
const previewImageUtr = ref(null);
const selectPaymentAccount = ref(null);
const utrCountDown = ref(6);
const showFileError = ref(false);
const showUtrError = ref(false);
const utrMsg = ref(null);

const t = ref(6);                  
const interval = ref(30);          
const angle = ref(0);              
const angle_increment = ref(360 / 9); 
const intervalCounter = ref(0);
const timerValue = ref(6);         
const timer = ref(null);           

const utrerror = ref(false);
const utrLimitError = ref(false);
const init = ref({
    utr: false,
    transaction_image_url: false
});

const hasEditedUtr = ref(0);
const paymentProofFileUploadStatus = ref('');
// ========== COMPUTED ==========
const depositAmount = computed(() => store.getters.depositAmount);
const selectedDepositPaymentMethod = computed(() => store.getters.selectedDepositPaymentMethod);

// ========== MOUNTED ==========
onMounted(() => {
    selectPaymentAccount.value = selectedDepositPaymentMethod.value;
});

// ========== METHODS ==========
function changeHasEditUtrStatus(){
    hasEditedUtr.value = 1;
}
function clearPaymentSlip() {
    previewImageUtr.value = null;
    utrNumber.value = '';
    file.value = undefined;
    utrerror.value = false;
    utrLimitError.value = false;
    hasEditedUtr.value = 1;
}

function clearUtrError() {
    if (utrNumber.value) {
        // original code references showUtrError (still kept)
        showUtrError.value = false;
    }
}

function toggleInit(bool) {
    init.value = {
        utr: bool,
        transaction_image_url: bool
    };
}

async function onUploadImageHandler(event) {
    try {
        paymentProofFileUploadStatus.value = 'Fetching payment proof file';
        const fileObj = event.target.files[0];
        if (!fileObj) {
            return $errorToast($t('no-file-selected','No File selected to upload'))
        }
        paymentProofFileUploadStatus.value = 'Payment Proof File found Ready to Process';
        const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg', 'image/webp'];

        if (!allowedTypes.includes(fileObj.type)) {
            return $errorToast('Invalid file type. Only JPG, JPEG, PNG, and WEBP are allowed and must be under 5 MB');
        }

        const maxFileSize = 5 * 1024 * 1024;
        if (fileObj.size > maxFileSize) {
            event.target.value = "";
            return $errorToast('Invalid file type. Only JPG, JPEG, PNG, and WEBP allowed under 5 MB');
        }

        previewImageUtr.value = URL.createObjectURL(fileObj);


        let response = await onUploadImage({
            event,
            depositAmount: depositAmount.value,
            startTimer: startTimer,
            resetTimer: resetTimer,
            sbtBtn: null,
            paymentProofFileUploadStatus
        });

        if (response) {
            if(!response?.manual_utr){
              paymentProofFileUploadStatus.value = 'UTR Number Not Found from above payment proof try with different one';
            }else{
                paymentProofFileUploadStatus.value = 'UTR Number Has been successfully extracted !!!';
            }
            utrNumber.value = response?.manual_utr;
            utrMsg.value = response?.utrMsg;
            file.value = response?.uploadedImage;
            previewImageUtr.value = response?.previewImage;
            utrLoader.value = false;
        }
        else{
            paymentProofFileUploadStatus.value = 'Unable to Extract the UTR Number From Above Uploaded File , Please try with another file or try again after sometime';
        }
    } catch (error) {
        $errorToast(error);
        paymentProofFileUploadStatus.value = 'Unable to Extract the UTR Number From Above Uploaded File , Please try with another file or try again after sometime';
    } finally{
        setTimeout(() => {
            paymentProofFileUploadStatus.value = '';
        }, 2000);
    }
}

function startTimer() {
    utrLoader.value = true;
    timer.value = setInterval(() => {
        intervalCounter.value++;
        angle.value += angle_increment.value / (1000 / interval.value);

        timerValue.value = t.value - Math.floor((angle.value / 360) * t.value);

        if (angle.value >= 360) {
            clearInterval(timer.value);
        }
        if (timerValue.value <= 0) {
            timerValue.value = 0;
            clearInterval(timer.value);
        }
    }, interval.value);
}

function updateCounter() {
    utrLoader.value = true;
    timer.value = setInterval(() => {
        intervalCounter.value++;
        angle.value += angle_increment.value / (1000 / interval.value);

        timerValue.value = t.value - Math.floor((angle.value / 360) * t.value);

        if (angle.value >= 360) {
            clearInterval(timer.value);
        }
        if (timerValue.value <= 0) {
            resetTimer();
            utrLoader.value = false;
        }
    }, interval.value);
}

function resetTimer() {
    clearInterval(timer.value);
    utrLoader.value = false;
    angle.value = 0;
    intervalCounter.value = 0;
    timerValue.value = t.value;
}

function getAutoUrlServiceCall() {
    let formData = new FormData();
    formData.append('file', file.value);
    formData.append('amount', depositAmount.value);

    $apiCall('post', 'GET_AUTO_UTR', formData, 'wallet', null, 'changeHeaderContent')
        .then(response => {
            if (response?.status === 200) {
                if (response?.data?.utr) {
                    utrNumber.value = response.data.utr;
                }
            }
        })
        .catch(error => {
            if (error) {
                $errorToast(error[0]);
            }
        });
}

async function walletDepositSubmitBtn() {
    try {
        toggleInit(true);
        if (selectPaymentAccount.value?.method != 'wallet' && utrNumber.value.length < 10) return;

        let response = await submitDepositAmount({
            accountDetails: selectPaymentAccount.value,
            uploadedImage: file.value,
            depositAmount: depositAmount.value,
            manual_utr: utrNumber.value,
            removeImage: removeImage,
            has_edited_utr: hasEditedUtr.value
        });
    } catch (error) {
        // original had commented error toast → kept exactly same
    }
}

function removeImage() {
    file.value = null;
    previewImageUtr.value = null;
}

function validateUTR() {
    utrNumber.value = utrNumber.value?.replace(/[^0-9]/g, '').replace(/[+-]/g, '');

    if (utrNumber.value == null || utrNumber.value == '') {
        utrerror.value = true;
        utrLimitError.value = false;
    } else if (utrNumber.value.length < 10 || utrNumber.value.length > 15) {
        utrLimitError.value = true;
        utrerror.value = false;
    } else {
        utrLimitError.value = false;
        utrerror.value = false;
    }
}
</script>
